import type { RouteComponentProps } from '@reach/router';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import * as ROUTES from '@constants/routes';

import AuthLayout, { BackLink, Subtitle } from '@layouts/AuthLayout';

const messages = defineMessages({
  sendAnother: {
    id: 'passwordReset.error.sendAnother',
    defaultMessage: 'Send Another',
  },
  tokenError: {
    id: 'passwordReset.error.tokenError',
    defaultMessage: 'Reset Error',
  },
  expiredToken: {
    id: 'passwordReset.error.expiredToken',
    defaultMessage:
      'Sorry, your token has expired. Please go back and try again.',
  },
  invalidToken: {
    id: 'passwordReset.error.invalidToken',
    defaultMessage:
      'Sorry, your token is invalid. Please go back and try again.',
  },
});

const ErrorForm: React.FC<
  RouteComponentProps & {
    tokenError?: string;
  }
> = ({ tokenError }) => {
  const { formatMessage } = useIntl();

  return (
    <AuthLayout title={formatMessage(messages.tokenError)}>
      <Subtitle>
        {tokenError === 'expired'
          ? formatMessage(messages.expiredToken)
          : formatMessage(messages.invalidToken)}
      </Subtitle>
      <BackLink to={ROUTES.FORGOT_PASSWORD}>
        {formatMessage(messages.sendAnother)}
      </BackLink>
    </AuthLayout>
  );
};

export default ErrorForm;
